export default {"src":"/_next/static/media/gemeente.479ae35c.svg","height":104,"width":200,"blurWidth":0,"blurHeight":0};